// this config expects following computed properties from the main component where riskReviewList is being used
// - product
// - risk
// - reviewData
export default {
    data() {
        return {
            reviewList: [],
            obligorReviewList: {
                title: 'Obligor(s)',
                value: []
            },
            guarantorReviewList: {
                title: 'Guarantor(s)',
                value: []
            },
            entityReviewList: {
                title: 'Entity(s) (updated)',
                value: []
            },
            excludedProperties: ['start_date', 'end_date', 'facility_id', 'risk_type'],
        }
    },
    computed: {
        risk() {
            return this.riskUnderReview;
        },
        isDeclaration() {
            return this.risk.risk_type === 'declaration';
        },
        isSubmissionChanges() {
            return !this.isDeclaration;
        },
        isStandalonePolicy() {
            return this.isDeclaration ? this.declaration.risk_structure === 'standalone_policy' : this.risk.risk_structure === 'standalone_policy';
        },
        reviewData() {
            if (this.isDeclaration) {
                return this.comparisonData;
            }

            const {comparisonData} = this;
            comparisonData.product_data = JSON.parse(comparisonData.product_data);

            return comparisonData;
        },
        informationSectionsItem() {
            const fieldChanges = this.reviewData;
            let newSections = [];
            let oldSections = [];

            if (this.isSubmissionChanges) {
                newSections = this.risk.information_sections;
                oldSections = fieldChanges.information_sections ? fieldChanges.information_sections : false;
            } else {
                oldSections = this.risk.information_sections;
                newSections = fieldChanges.information_sections ? fieldChanges.information_sections : false;
            }


            if (Boolean(oldSections) || Boolean(newSections)) {
                const informationSectionsUpdated = this.userIsInsurer && Boolean(newSections) ? this.getHasInsurerInformationSectionsChanged(oldSections, newSections) : Boolean(newSections);

                return {
                    text: 'Additional information' + (informationSectionsUpdated ? ' (updated)' : ''),
                    value: informationSectionsUpdated ? newSections : oldSections
                };
            }

            return false;
        },
        reviewListSummary() {
            if (this.reviewData === undefined || this.currencies.length === 0 || this.sectors.length === 0) {
                return;
            }

            this.reviewList = [];
            let summaryReviewList = [];
            let reviewObject = null;
            const fieldChanges = this.reviewData;
            const self = this;
            this.obligorReviewList = {
                title: this.isStandalonePolicy ? 'Borrower(s)' : 'Obligor(s)',
                value: []
            };

            this.guarantorReviewList = {
                title: 'Guarantor(s)',
                value: []
            };

            if (this.isDeclaration) {
                this.excludedProperties.push('requested_waiting_period');
            } else {
                this.excludedProperties.push('waiting_period');
            }

            if (this.isStandalonePolicy) {
                this.excludedProperties.push('prior_experience');
            }

            // looping through product configs
            const productFields = this.productQuestions.map(({field}) => field);
            const relatedProperties = this.relatedProperties.filter(({field}) => !productFields.includes(field));
            this.productQuestions.concat(relatedProperties).forEach(config => {
                reviewObject = self.addToReviewList(config.field, self.isProductDataProperty(config));
                if (reviewObject !== null) { summaryReviewList.push(reviewObject); }
            });

            if (this.isSubmissionChanges) {
                self.addToReviewList('sub_sector_id');

                return summaryReviewList;
            }

            // looping through field changes to see if any property is not taken
            Object.keys(fieldChanges).forEach(function (currentValue) {
                if (currentValue === 'current_contract_value' && summaryReviewList.some(({property}) => property === 'contract_value')) {
                    return;
                }
                if (currentValue === 'product_data') {
                    Object.keys(fieldChanges[currentValue]).forEach(function (currentValue) {
                        if (!self.productHasProperty(currentValue) && currentValue !== 'limit_of_liability') {
                            reviewObject = self.addToReviewList(currentValue, true);
                            if (reviewObject !== null) { summaryReviewList.push(reviewObject); }
                        }
                    });
                } else if (!self.productHasProperty(currentValue)) {
                    reviewObject = self.addToReviewList(currentValue);
                    if (reviewObject !== null) { summaryReviewList.push(reviewObject); }
                }
            });

            return summaryReviewList;
        }
    },
    methods: {
        addToReviewList(property, isProductData = false) {
            //if it is part of excluded properties
            if (this.excludedProperties.includes(property)) {
                return null;
            }

            const reviewObject = isProductData ? this.getProductDataObject(property) : this.getProductObject(property);

            if (!reviewObject || ['lines', 'new_lines', 'information_sections', 'updated_at', 'country_id'].includes(property)) {
                return null;
            }

            if (this.isSubmissionChanges) {
                return {
                    property,
                    text: reviewObject.text,
                    newValue: reviewObject.oldValue,
                    oldValue: reviewObject.newValue,
                };
            }

            return {
                property,
                ...reviewObject,
            };
        },
        getProductObject(property) {
            const fieldChanges = this.reviewData;
            const question = this.getQuestionByProperty(property);

            let oldValue = '';
            let newValue = fieldChanges[property];
            let fieldText = this.productHasProperty(property) ? this.getPropertyLabel(property) : property.replace(/_/gu, " ");

            if (property === 'currency_id') {
                fieldText = 'Currency';
                oldValue = this.risk.currency.code;

                const newCurrency = this.currencies.find(currency => this.reviewData.currency_id === currency.id) || {};
                newValue = newCurrency.code || '';
            } else if (property === 'total_risk_period') {
                if (this.isDeclaration) {
                    const startDate = this.$moment(this.risk.inception_date);
                    const endDate = this.$moment(this.risk.expiry_date);
                    const totalRiskPeriod = endDate.diff(startDate, 'days');

                    oldValue = this.$options.filters.yearsAndDays(totalRiskPeriod);
                    newValue = typeof newValue !== 'undefined' ? this.$options.filters.yearsAndDays(newValue) : newValue;
                } else if (this.risk.firm_orders !== null) {
                    const startDate = this.$moment(this.risk.firm_orders[0].inception_date);
                    const endDate = this.$moment(this.risk.firm_orders[0].expiry_date);
                    const totalRiskPeriod = endDate.diff(startDate, 'days');
                    newValue = this.$options.filters.yearsAndDays(totalRiskPeriod);
                    oldValue = typeof oldValue !== 'undefined' ? this.$options.filters.yearsAndDays(oldValue) : oldValue;
                } else {
                    newValue = !this.isEmpty(newValue) ? this.$options.filters.yearsAndDays(newValue) : newValue;
                    oldValue = !this.isEmpty(oldValue) ? this.$options.filters.yearsAndDays(oldValue) : oldValue;
                }
            } else if (property === 'waiting_period' && this.isDeclaration) {
                oldValue = this.$options.filters.yearsAndDays(this.risk.waiting_period);
                newValue = typeof newValue !== 'undefined' ? this.$options.filters.yearsAndDays(newValue) : newValue;
            } else if (property === 'requested_waiting_period' && !this.isDeclaration) {
                oldValue = this.$options.filters.yearsAndDays(this.risk.requested_waiting_period);
                newValue = !this.isEmpty(oldValue) ? this.$options.filters.yearsAndDays(oldValue) : oldValue;
            } else if (property === 'contract_value') {
                oldValue = this.risk.current_contract_value ?? this.risk.contract_value;
                oldValue = this.applyFormatFilter(oldValue, 'currency', this.getCurrencyCode());
                newValue = fieldChanges['current_contract_value'] ?? fieldChanges[property];
                newValue = this.applyFormatFilter(newValue, 'currency', this.getCurrencyCode(true));
            } else if (property === 'current_contract_value' || property === 'limit_of_liability') {
                oldValue = this.applyFormatFilter(this.risk[property], 'currency', this.getCurrencyCode());
                newValue = this.applyFormatFilter(fieldChanges[property], 'currency', this.getCurrencyCode(true));
            } else if (['indemnity'].includes(property)) {
                oldValue = this.applyFormatFilter(this.risk[property], 'percent');
                newValue = this.applyFormatFilter(fieldChanges[property], 'percent');
            } else if (['taxes_payable_by_insured', 'taxes_payable_by_insurer'].includes(property)) {
                oldValue = this.risk[property] + '%';
                newValue = fieldChanges[property] + '%';
            } else if (property === 'net_margin' || property === 'gross_margin') {
                const suffix = question && question.hasOwnProperty('suffix') ? question.suffix : '';
                oldValue = this.risk[property] ? this.risk[property] + ' ' + suffix : '';
                newValue = fieldChanges[property] ? fieldChanges[property] + ' ' + suffix : '';
            } else if (property === 'inception_date' || property === 'expiry_date') {
                oldValue = this.$moment(this.risk[property]).format('YYYY-MM-DD');
                newValue = fieldChanges[property] ? this.$moment(fieldChanges[property]).format('YYYY-MM-DD') : '';
            } else if (property === 'sub_sector_id') {
                this.addSector(this.reviewData.sub_sector_id);
                return;
            } else if (property === 'entity_id') {
                fieldText = 'Entity';
                oldValue = this.getEntityName(this.risk[property]);
                newValue = fieldChanges[property] ? this.getEntityName(fieldChanges[property]) : '';
            } else if (property === 'obligors' || property === 'guarantors') {
                this.addObligorGuarantors(property);
                return;
            } else if (property === 'risk_codes') {
                oldValue = this.getRiskCodesSumary(this.risk.riskCodes);
                newValue = this.getRiskCodesSumary(fieldChanges[property]);
            } else if (['with_borrower', 'with_guarantor'].includes(property)) {
                oldValue = this.$options.filters.yesOrNo(this.risk[property]);
                newValue = this.$options.filters.yesOrNo(fieldChanges[property]);
            } else if (['choice_of_law_id', 'country_of_origin_id', 'regulatory_risk_location_id'].includes(property)) {
                oldValue = this.getCountryName(this.risk[property]);
                newValue = this.getCountryName(fieldChanges[property]);
            } else if (property === "broker_address") {
                oldValue = this.risk.broker_address.line1;
                newValue = fieldChanges[property];
            } else if (property === "broker_country") {
                oldValue = this.getCountryName(this.risk.broker_address.country_id);
                newValue = this.getCountryName(fieldChanges[property]);
            } else if (property === 'entities') {
                this.addEntities(fieldChanges[property]);
                return;
            } else {
                oldValue = this.risk[property];
                newValue = fieldChanges[property];
            }

            return {
                text: fieldText,
                newValue: newValue,
                oldValue: oldValue != newValue ? oldValue : '',
            };
        },
        getProductDataObject(property) {
            const fieldChanges = this.reviewData;

            let fieldText = this.productHasProperty(property) ? this.getPropertyLabel(property) : property.replace(/_/gu, " ");
            let oldValue = this.risk.product_data[property];
            let newValue = fieldChanges.hasOwnProperty('product_data') ? fieldChanges.product_data[property] : undefined;

            const question = this.getQuestionByProperty(property);
            if (this.productHasProperty(property)) {
                const productDataField = question;
                const suffix = productDataField.hasOwnProperty('suffix') ? productDataField.suffix : '';

                fieldText = productDataField.label;
                oldValue = this.applyFormatFilter(oldValue, productDataField.type, this.getCurrencyCode()) + suffix;

                if (property === 'total_contract_value') {
                    newValue = this.applyFormatFilter(newValue, 'currency', this.getCurrencyCode(true));
                } else if (typeof newValue !== 'undefined') {
                    newValue = this.applyFormatFilter(newValue, productDataField.type, this.getCurrencyCode(true)) + suffix;
                }
            }

            return {
                text: fieldText,
                oldValue: oldValue,
                newValue: newValue,
            };
        },
        addSector(subSectorId) {
            const self = this;
            this.sectors.forEach(function (sector) {
                sector.sub_sector.forEach(function (subSector) {
                    if (subSector.id === subSectorId && Boolean(self.risk.sub_sector)) {
                        self.reviewList.push({
                            text: 'Sector',
                            oldValue: self.risk.sub_sector.sector.name,
                            newValue: sector.name
                        });

                        self.reviewList.push({
                            text: 'Sub sector',
                            oldValue: self.risk.custom_sub_sector ? self.risk.custom_sub_sector : self.risk.sub_sector.name,
                            newValue: subSector.name
                        });
                    }
                });
            });
        },
        addObligorGuarantors(property) {
            const fieldChanges = this.reviewData;
            const self = this;
            let idToPickup = '';
            let title = '';
            let pushObj = []
            if (property === 'obligors') {
                idToPickup = 'obligor_id';
                title = this.isStandalonePolicy ? 'Borrower' : 'Obligor';
                pushObj = self.hasObligor ? self.obligorReviewList.value : self.reviewList;
            } else if (property === 'guarantors') {
                idToPickup = 'guarantor_id';
                title = 'Guarantor';
                pushObj = self.hasObligor ? self.guarantorReviewList.value : self.reviewList;
                if (this.hasObligor && (typeof fieldChanges[property][0].pivot !== 'undefined') && fieldChanges[property][0].pivot.guarantor_id === null && this.risk[property].length !== 0) {
                    self.guarantorReviewList.title = `${self.guarantorReviewList.title} (updated)`;
                    pushObj.push({
                        text: 'Add guarantor?',
                        oldValue: 'Yes',
                        newValue: 'No',
                    });
                    return;
                } else if (this.hasObligor && (typeof fieldChanges[property][0].pivot !== 'undefined') && fieldChanges[property][0].pivot.guarantor_id === null && this.risk[property].length === 0) {
                    self.guarantorReviewList.title = `${self.guarantorReviewList.title} (updated)`;
                    pushObj.push({
                        text: 'Add guarantor?',
                        oldValue: 'No',
                        newValue: '',
                    });
                    return;
                }
            }

            fieldChanges[property].forEach(function (row, index) {
                const oldValue = self.risk[property].find(oldValue => oldValue.id === row.id);
                pushObj.push({
                    text: title,
                    oldValue: typeof oldValue !== 'undefined' ? self.getObligorName(oldValue.pivot[idToPickup]) : '',
                    newValue: typeof row.pivot !== 'undefined' && typeof row.pivot[idToPickup] !== 'undefined' ? self.getObligorName(row.pivot[idToPickup]) : '',
                });
                if (self.hasObligor) {
                    pushObj[pushObj.length - 1].id = index + 1;
                }
                if (!self.hasObligor && typeof fieldChanges.country_id !== 'undefined' && property === 'obligors') {
                    row.country_id = fieldChanges.country_id;
                }
                pushObj.push({
                    text: 'Country',
                    oldValue: typeof oldValue !== 'undefined' ? self.getCountryName(oldValue.country_id) : '',
                    newValue: typeof row.country_id !== 'undefined' ? self.getCountryName(row.country_id) : '',
                });
                if (self.hasObligor && property === 'obligors') {
                    pushObj.push({
                        text: 'Sub Limit',
                        oldValue: typeof oldValue !== 'undefined' ? self.applyFormatFilter(oldValue.pivot.sub_limit, 'currency', self.getCurrencyCode()) : '',
                        newValue: typeof row.pivot !== 'undefined' && typeof row.pivot.sub_limit !== 'undefined' ? self.applyFormatFilter(row.pivot.sub_limit, 'currency', self.getCurrencyCode(true)) : '',
                    });
                }
            });
            if (self.hasObligor) {
                const isChanged = this.isObligorGuarantorsChanged(property, pushObj);
                if (property === 'obligors') {
                    self.obligorReviewList.title = `${self.obligorReviewList.title} ${isChanged ? ' (updated)' : ''}`;
                } else if (property === 'guarantors') {
                    self.guarantorReviewList.title = `${self.guarantorReviewList.title} + ${isChanged ? ' (updated)' : ''}`;
                }
            }
        },
        addEntities(entities) {
            entities.forEach(entity => {
                const oldEntityRecord = this.findEntityInCurrentRisk(entity.entity_id);
                const currentEntityOrderNumber = this.entityReviewList.value.length < 1 ? 1 : this.entityReviewList.value.length % 3;

                const oldEntityName = oldEntityRecord ? oldEntityRecord.entity.name : '';
                const newEntityName = this.getEntityName(entity.entity_id);
                this.addRowToTheReviewList(this.entityReviewList, 'Entity', oldEntityName, newEntityName, currentEntityOrderNumber);

                const oldEntityAddress = oldEntityRecord ? oldEntityRecord.address.line1 : '';
                const newEntityAddress = entity.address;
                this.addRowToTheReviewList(this.entityReviewList, 'Address', oldEntityAddress, newEntityAddress);
            });
        },
        findEntityInCurrentRisk(entityId) {
            return this.risk.entities?.find((entity) => {
                return entity.entity_id === entityId;
            });
        },
        addRowToTheReviewList(reviewList, field, oldValue, newValue, id = null) {
            let row = {
                text: field,
                oldValue: oldValue,
                newValue: newValue
            };

            if (id) {
                row.id = id;
            }

            reviewList.value.push(row);
        },
        isObligorGuarantorsChanged(property, pushObj) {
            if (this.reviewData[property].length !== this.risk[property].length) {
                return true;
            }
            return pushObj.some(function (obligor) {
                if (obligor.newValue !== '') {
                    return true;
                }
                return false;
            });
        },
        getObligorName(id = null) {
            if (id) {
                return this.obligors.find(obligor => obligor.id === id).name
            }
            return '';
        },
        getFormattedId(id) {
            return id + '.';
        },
        getFacilitySecurity(securityId) {
            return this.risk.facility?.securities.find(security => security.id === securityId) || {};
        },
        getEntityName(id) {
            return this.entities.find((enitity) => id === enitity.id)?.name || ''
        },
        getRiskCodeName(id) {
            return this.riskCodes.find((enitity) => id === enitity.id)?.name || ''
        },
        isEmpty(value) {
            return !value || typeof oldValue !== 'undefined';
        },
        getHasInsurerInformationSectionsChanged(oldSections, newSections) {
            if (typeof oldSections !== 'undefined' && typeof newSections !== 'undefined' && oldSections.length !== newSections.length) {
                return true;
            }

            return newSections.some(function (section, index) {
                const oldSection = oldSections[index];

                if (!section.hasOwnProperty('id') ||
                    section.id !== oldSection.id ||
                    section.name !== oldSection.name ||
                    section.content !== oldSection.content
                ) {
                    return true;
                }

                return false;
            });
        },
        getRiskCodesSumary(riskCodes) {
            return riskCodes?.map((riskCode) => {
                return this.getRiskCodeName(riskCode.risk_code_id) + ": " + this.applyFormatFilter(riskCode.value, 'percent');
            }).join(', ');
        }
    }
};
